<template>
    <div class="p-4 bg-white mb-4">

        <div class="d-flex text-lg mb-3">
            <div class="px-3 py-1 border-2 border-r-0 cursor-pointer" title="List View" style="border-radius: 5px 0 0 5px;background: #dbe1e7;" @click="takeToProjectListPage()">
                <i aria-hidden="true" class="fa fa-bars"></i>
            </div>
            <div class="px-3 py-1 border-2 border-l-0 cursor-pointer" title="Kanban View" style="border-radius: 0 5px 5px 0;background: #38b2b0;color: white;">
                <i aria-hidden="true" class="fa fa-th"></i>
            </div>
        </div>

        <div class="mb-4 d-flex ml-2 justify-between" v-if="showFilters">
            <div class="kanban-grouping-filter mr-2">
                <label class="text-sm text-grey-darkest">Group By</label>
                <multiselect class="cursor-pointer" :options="groupByOptions" v-model="selectedGroupBy" @input="updateUserKanbanSettings()" :show-labels="true" track-by="id" label="name" :multiple="false"></multiselect>
            </div>
            <div class="kanban-grouping-filter mr-2">
                <label class="text-sm text-grey-darkest">Sub-group By</label>
                <multiselect class="cursor-pointer" :options="subgroupByOptions" v-model="selectedSubgroupBy" @input="updateUserKanbanSettings()" :show-labels="true" track-by="id" label="name" :multiple="false"></multiselect>
            </div>
            <div class="kanban-grouping-filter mr-2">
                <label class="text-sm text-grey-darkest">Filter by User</label>
                <multiselect class="cursor-pointer" :options="usersOptions" v-model="selectedUser" @input="updateUserKanbanSettings()" :show-labels="false" track-by="id" label="name" :multiple="true"></multiselect>
            </div>
            <div class="kanban-grouping-filter mr-2" style="flex-grow: 0.3;">
                <label class="text-sm text-grey-darkest">Search <i v-if="filter.loadingData" class="fa fa-spin fa-spinner text-grey-darkest ml-1"
                                                                   aria-hidden="true"></i></label>
                <input
                    v-model="searchText"
                    @input="applyKanbanSearch"
                    class="form-control mb-3 shadow-none bg-grey-lighter text-grey-darkest focus:outline-none p-2 rounded-full text-sm border-0 focus:bg-grey-lighter pl-3"
                    placeholder="Search by name or ID..."
                    type="search"
                />
            </div>
            <div class="kanban-grouping-filter text-right">
                <label class="text-sm text-grey-darkest w-full invisible ">Customize</label>
                <button type="button" class="btn btn-outline-primary" @click.prevent="showCustomizePanel()">
                    <i class="fa fa-fw text-left fa-btn fa-cog pointer mr-1" tabindex="0"></i> Customize
                </button>
            </div>
        </div>

        <div id="kanban-loader-overlay" class="kanban-loader-overlay" v-show="showKanbanLoader">
            <div class="kanban-loader-content">
                <i class="fa fa-spinner fa-spin"></i>
                <span>Updating board, please wait...</span>
            </div>
        </div>
        <div style="position: relative;">
            <div id="kanban-container" v-show="projects.length > 0 && selects && !showLoader"></div>
            <div class="p-4 bg-white mb-4 text-center" style="font-size: 30px;" v-if="projects.length === 0 && !showLoader">
              <p class="w-100 text-center m-3 p-3">No project found. Please try changing Filters</p>
            </div>
            <div class="p-4 bg-white mb-4 text-center" style="font-size: 30px;" v-else-if="showLoader">
                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
            </div>
        </div>


        <div id="projectCommentModal" class="modal fade" role="dialog">
            <div class="modal-dialog" style="max-width: 870px">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="projectCommentForm.sales_status" class="modal-title text-lg">
                            {{ 'Required comment for: "' + projectCommentForm.sales_status.full_description + '" Sales Status' }}
                        </h4>
                        <h4 v-else class="modal-title text-lg">Add Comment</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal" @click="closeProjectCommentModal()">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="projectCommentForm.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <ckeditor-container id="comment" v-model="projectCommentForm.comment" :options="users"
                                                    @mention="addMention" mentionFrom="name"></ckeditor-container>
                                <div class="text-red text-xs" v-if="projectCommentForm.errors.has('comment')">{{
                                        projectCommentForm.errors.get('comment')
                                    }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <span v-if="this.projectCommentForm.saving">
                            <button type="button" disabled
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                <i class="fa fa-btn fa-spinner fa-spin"></i> Saving
                            </button>
                        </span>
                        <span v-else>
                            <button type="button" id="save-project-comment" name="save-project-comment"
                                    @click.prevent="projectCommentSaved(null)"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </span>
                    </div>
                </div>

            </div>
        </div>

        <div class="modal fade" v-if="isSidePanelOpen" id="kanbanProjectQuickView" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">{{ tempCardData.name }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeKanbanProjectQuickView()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white" v-if="projectQuickViewData">
                        ...
                    </div>
                    <div class="modal-body bg-white text-center text-2xl" v-else>
                        <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    </div>
                    <div class="modal-footer bg-white" v-if="projectQuickViewData">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary">Save changes</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isCustomizePanel" class="kanban-side-panel bg-white border-left p-3 shadow slide-in-right" >
            <div class="side-panel-header d-flex justify-content-between align-items-center mb-3 border-b-1 pb-3">
                <h5 class="mb-0">Layout Options</h5>
                <button class="close" @click.prevent="hideCustomizePanel()">&times;</button>
            </div>
            <div class="side-panel-content">
                <small class="text-muted">Card layout</small>

                <div class="option-row mt-1 d-flex justify-content-between align-items-center">
                    <span>Card size</span>
                    <b-dropdown variant="link" right :text="layoutSetting.cardSize" class="p-0">
                        <b-dropdown-item @click="cardSize('Small')">Small</b-dropdown-item>
                        <b-dropdown-item @click="cardSize('Medium')">Medium</b-dropdown-item>
                        <b-dropdown-item @click="cardSize('Large')">Large</b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="option-row mt-1 d-flex justify-content-between align-items-center kanban-toggle-custom my-2">
                    <span id="project-comment-kanban-option">Project Comment</span>
                    <b-form-checkbox v-model="layoutSetting.comment" name="project-comment-kanban-option" switch>
                    </b-form-checkbox>
                </div>
                <div class="option-row mt-1 d-flex justify-content-between align-items-center">
                    <span>Sorting Options</span>
                    <b-dropdown variant="link" right :text="layoutSetting.sortColumn" class="p-0">
                        <b-dropdown-item @click="projectSortingColumn('Project Name')">Project Name</b-dropdown-item>
                        <b-dropdown-item @click="projectSortingColumn('Project Log Date')">Project Log Date</b-dropdown-item>
                        <b-dropdown-item @click="projectSortingColumn('Recent Activity')">Recent Activity</b-dropdown-item>
                    </b-dropdown>
                    <b-dropdown variant="link" right :text="layoutSetting.sortDirection" class="p-0">
                        <b-dropdown-item @click="projectSortingDirection('Ascending')">Ascending</b-dropdown-item>
                        <b-dropdown-item @click="projectSortingDirection('Descending')">Descending</b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="option-row mt-1 mb-4">
                    <div>Fields</div>
                    <draggable v-model="layoutSetting.allProjectFieldsForCards">
                        <transition-group class="border-1" style="height: 300px !important; display: block; overflow-y: scroll !important; margin-top: 10px; border-radius: 5px; padding: 5px 0;">
                            <span class="d-block cursor-move kanban-field-check hover:text-white bg-teal" v-for="projectField in layoutSetting.allProjectFieldsForCards" :key="projectField.key" style="background: #8080800d;padding: 5px 20px;margin: 0;width: 95%;margin: 0 auto;border-radius: 5px; margin-bottom: 3px; margin-top:3px;padding-left: 10px;"
                                 :id="projectField.key">
                                <i class="fa fa-bars mr-2" aria-hidden="true"></i>
                                <b-form-checkbox
                                    :id="'field-checkbox-'+projectField.key"
                                    v-model="projectField.checked"
                                    :name="projectField.name"
                                    value=true
                                    unchecked-value=false
                                    :key="projectField.key"
                                    :disabled="(projectField.id  === 'id')"
                                >
                                {{projectField.name}}
                                </b-form-checkbox>
                            </span>
                        </transition-group>
                    </draggable>
                </div>

                <small class="text-muted" v-show="selectedGroupBy.id === 'sales_status_code'">Board layout</small>
                <div class="option-row mt-1" v-show="selectedGroupBy.id === 'sales_status_code'">
                    <div>Column Settings</div>
                    <draggable v-model="layoutSetting.salesStatusColumn">
                        <transition-group class="border-1" style="height: 300px !important; display: block; overflow-y: scroll !important; margin-top: 10px; border-radius: 5px; padding: 5px 0;">
                            <span class="d-block cursor-move kanban-field-check hover:text-white bg-teal" v-for="salesColumn in layoutSetting.salesStatusColumn" :key="salesColumn.key" style="background: #8080800d;padding: 5px 20px;margin: 0;width: 95%;margin: 0 auto;border-radius: 5px; margin-bottom: 3px; margin-top:3px;padding-left: 10px;"
                                  :id="salesColumn.key">
                                <i class="fa fa-bars mr-2" aria-hidden="true"></i>
                                <b-form-checkbox
                                    :id="'sales-column-checkbox-'+salesColumn.key"
                                    v-model="salesColumn.checked"
                                    :name="salesColumn.code"
                                    value=true
                                    unchecked-value=false
                                    :key="salesColumn.key"
                                    :disabled="(salesColumn.id  === 'id')"
                                >
                                {{salesColumn.code}}
                                </b-form-checkbox>
                            </span>
                        </transition-group>
                    </draggable>
                </div>
            </div>
            <div class="side-panel-footer">
                <button class="btn btn-primary" @click="updateUserKanbanSettings()">Save</button>
            </div>
        </div>


        <div id="projectCommentSectionModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg" data-keyboard="false" data-backdrop="static">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            {{ (projectQuickViewData)? projectQuickViewData.name:'Project' }} Comments
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal" @click="closeProjectCommentSectionModal()">close
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="projectKanbanCommentDiv" v-if="loadProjectForComment">
                            <project-kanban-comments
                                ref="ProjectKanbanComments"
                                :project="projectQuickViewData"
                                :isAdmin="isAdmin"
                                :canEdit="canEdit"
                                :user="loginUser"
                                :isPM="false"
                                :teamDeadSalesStatusIds="teamDeadSalesStatusIds"
                                :codes="selects"
                                v-if="layoutSetting.comment && projectQuickViewData"
                            ></project-kanban-comments>
                        </div>
                        <div class="projectKanbanCommentDiv" v-else>
                            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i> Loading Data
                        </div>
                        <div class="mt-3">
                            <ckeditor-container id="comment" v-model="projectCommentForm.comment" :options="users"
                                                @mention="addMention" mentionFrom="name"></ckeditor-container>
                        </div>
                    </div>
                    <div class="modal-footer bg-white">
                        <span>
<!--                            <button type="button" id="save-project-comment" name="save-project-comment" @click="projectCommentSaved('projectCommentModalSaveAndClose')"-->
<!--                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">-->
<!--                                Save And Close-->
<!--                            </button>-->
                            <button type="button" id="save-project-comment" name="save-project-comment" @click="projectCommentSaved('projectCommentModal')"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </span>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import { Kanban } from '@syncfusion/ej2-kanban';
import { registerLicense } from '@syncfusion/ej2-base';
import axios from "axios";
import Multiselect from 'vue-multiselect';
import Form from "../../utils/form";
import draggable from "vuedraggable";
import { Query } from '@syncfusion/ej2-data';
import ProjectKanbanComments from "./project-kanban-comments.vue";



export default {
    name: 'project-kanban',
    components: {ProjectKanbanComments, draggable, Multiselect },
    props: [
        'selects',
        'loginUser',
        'users',
        'filters',
        'layoutSettings',
        'cardFieldSettings',
        'allProjectFields',
        'teamDeadSalesStatusIds',
        'isAdmin',
        'canEdit',
    ],
    data() {
        return {
            projects: [],
            columnsKanban: [
                { headerText: 'To Do', keyField: 'Open', allowToggle: true },
                { headerText: 'In Progress', keyField: 'In Progress', allowToggle: true },
                { headerText: 'Done', keyField: 'Done', allowToggle: true }
            ],
            dataKanban: [],
            selectedUser: (this.filters && this.filters.hasOwnProperty('users'))? this.filters.users:[],
            showLoader: true,
            kanban: null,
            selectedGroupBy: (this.filters && this.filters.hasOwnProperty('groupBy'))? this.filters.groupBy:{
                id: 'sales_status_code',
                name: 'Sales Status'
            },
            groupByOptions: [],
            subgroupByOptions: [],
            selectedSubgroupBy: (this.filters && this.filters.hasOwnProperty('subgroupBy'))? this.filters.subgroupBy:null,
            showFilters: false,
            swimlaneRow: [],
            tempCardData: null,
            tempCardValue: null,
            projectCommentForm: new Form({
                id: null,
                comment: '',
                date: '',
                project_id: null,
                company_contact_id: null,
                sales_status_id: null,
                sales_status: null,
                mentioned_users: [],
                saving: false,
                commentAddFrom:null,
                deadReason: null,
            }),
            isSidePanelOpen: false,
            projectQuickViewData: null,
            isCustomizePanel: false,
            layoutSetting: (this.layoutSettings)? this.layoutSettings : {
                cardSize: 'Medium',
                comment: 'false',
                sortColumn: 'Recent Activity',
                sortDirection: 'Descending',
                allProjectFieldsForCards: this.allProjectFields,
                salesStatusColumn: this.getSalesStatusColumnsFormated()
            },
            cardFieldSetting: null,
            cardTemplate: '<div class="custom-kanban-card"><div class="card-header">#\${id}</div><div class="card-body"><a class="project-link" href="/project/\${id}/edit">\${name}</a></div></div>',
            searchText: '',
            keysForSearch: [],
            loadProjectForComment: false,
            cardToUpdate: null,
            usersOptions: [{id: 0, name: 'Company'}].concat(this.selects.users),
            filter: {
                timeout: null,
                loadingData: false,
            },
            fullKanbanData: [],
            cardUpdateCount: 0,
            showKanbanLoader: false,
            projectToFetch: 100,
            nextPageToGet: true,
            columnToFetchDataFor: null,
            previousLayoutSetting: null,
            projectToSkip: 0,
        };
    },
    mounted() {
        this.getKanbanGroupAndSubgroupFields();
    },
    methods: {
        loadKanban() {
            this.$nextTick(() => {
                registerLicense(this.syncfusionKanbanLicenseKey);
                let self = this;
                let safeHeaders = self.swimlaneRow.map(row => ({
                    key: row.key,
                    text: row.text
                }));
                self.dataKanban = self.projects.map(item => {
                    let originalKey = item.swimlaneColumn;
                    let prefixedRow = safeHeaders.find(r => r.key.endsWith(`_${originalKey}`));
                    return {
                        ...item,
                        swimlaneColumn: prefixedRow?.key || 'Unassigned',
                        swimlaneColumnOld: prefixedRow?.key || 'Unassigned',
                        account_manager_name: item.account_manager_name?.trim() || 'No Account Manager'
                    };
                });
                let existingSwimlaneKeys = new Set(self.dataKanban.map(card => card.swimlaneColumn));
                safeHeaders.forEach(row => {
                    if (!existingSwimlaneKeys.has(row.key)) {
                        self.dataKanban.push({
                            id: `__dummy__${row.key}`,
                            Status: self.columnsKanban[0]?.keyField || 'Open',
                            name: '__DUMMY__',
                            swimlaneColumn: row.key,
                            isDummy: true
                        });
                    }
                });
                let container = document.querySelector('#kanban-container');
                if (container) container.innerHTML = '';

                let sortColumn = 'updated_at';
                switch (self.layoutSetting.sortColumn) {
                    case 'Project Name':
                        sortColumn = 'name';
                        break;
                    case 'Project Log Date':
                        sortColumn = 'created_at';
                        break;
                    case 'Recent Activity':
                        sortColumn = 'updated_at';
                        break;
                }

                let kanbanConfig = {
                    dataSource: self.dataKanban,
                    keyField: 'Status',
                    columns: self.columnsKanban,
                    cardSettings: {
                        contentField: 'name',
                        headerField: sortColumn,
                        template: '\${cardTemplate}',
                    },
                    dialogSettings: {
                        template: null // disable default dialog
                    },
                    cardClick: function (args) {

                        let target = args.event.target || args.event.srcElement;
                        while (target && !target.classList.contains('e-card')) {
                            target = target.parentElement;
                        }
                        let cardId = target ? target.getAttribute('data-uid') || target.getAttribute('data-id') : null;
                        let cardData = null;

                        if (cardId) {
                            cardData = self.dataKanban.find(item => item.id == cardId);
                        }

                        if (!cardData) {
                            cardData = args.data;
                        }
                        self.tempCardData = cardData;


                        var clickEvent = args.event;
                        if (
                            clickEvent.srcElement &&
                            clickEvent.srcElement.classList.contains('projectCommentIcon')
                        ) {
                            self.projectCommentForm.project_id = self.tempCardData.id;
                            self.projectCommentModalOpen();
                        } else {
                            window.location = self.editProject(self.tempCardData);
                        }


                        // self.tempCardData = args.data;
                        // var clickEvent = args.event;

                        // if (clickEvent.srcElement && clickEvent.srcElement.classList.contains('projectCommentIcon')) {
                        //     self.projectCommentForm.project_id = self.tempCardData.id;
                        //     self.projectCommentModalOpen();
                        // } else {
                        //     window.location = self.editProject(self.tempCardData);
                        // }

                        // window.location = self.editProject(self.tempCardData);
                        // if(!self.isSidePanelOpen){
                        //     self.isSidePanelOpen = true;
                        //     self.$nextTick(() => {
                        //         $('#kanbanProjectQuickView').modal('show');
                        //     });
                        // }
                        // self.projectQuickViewData = null;
                        // self.getPanelProjectData();
                    },
                    cardDoubleClick: function (args) {
                        args.cancel = true;
                    }
                };


                if (self.selectedSubgroupBy) {
                    kanbanConfig.swimlaneKey = 'swimlaneColumn';
                    kanbanConfig.swimlaneSettings = {
                        keyField: 'swimlaneColumn',
                        showEmptyRow: true,
                        showItemCount: true,
                        allowToggle: true,
                        headers: safeHeaders,
                        allowDragAndDrop: false
                    };
                }
                kanbanConfig.cardRendered = (args) => {
                    // args.element === <div class="e-card …">
                    args.element.setAttribute('data-uid', args.data.id);
                };

                if(self.selectedSubgroupBy){
                    let subGroupSwimlaneTempOptionsArray = [
                        'contract_type',
                        'client_profile',
                        'lead_from',
                        'marketing_status',
                        'office',
                        'products_and_services',
                        'estimator_id',
                        'take_off_person_id',
                        'account_manager_id',
                    ];
                    if(subGroupSwimlaneTempOptionsArray.includes(self.selectedSubgroupBy.property_name)){
                        kanbanConfig.swimlaneSettings.allowDragAndDrop = true;
                    }
                }

                kanbanConfig.dragStart = function(args) {
                    let cardId = null;
                    // Try to get from DOM
                    if (args.event && args.event.target) {
                        let el = args.event.target.closest('.e-card');
                        if (el) {
                            cardId = el.getAttribute('data-uid') || el.getAttribute('data-id');
                        }
                    }
                    // Fallback to args.data
                    if (!cardId && args.data && args.data[0]) {
                        cardId = args.data[0].id;
                    }
                    // Find in your data source
                    if (cardId) {
                        let card = self.dataKanban.find(c => c.id == cardId);
                        self.tempCardData = card;
                        self.cardToUpdate = card;
                    }
                };
                kanbanConfig.dragStop = function(args) {
                    let newStatus = null;
                    let newSwimLane = null;
                    let eventTarget = (args.target || args.event && args.event.target);

                    if (eventTarget) {
                        let col = eventTarget.closest('.e-content-cells[data-key]');
                        if (col) {
                            newStatus = col.getAttribute('data-key');
                        }
                    }

                    if (!newStatus && args.data && args.data[0]) {
                        newStatus = args.data[0].Status;
                    }
                    if (args.data && args.data[0]) {
                        newSwimLane = args.data[0].swimlaneColumn;
                    }

                        console.log('dragStop: card data', args, !args.data || !args.data[0], !args.data,!args.data[0]);
                    if (!args.data || !args.data[0]) {
                        console.log('dragStop: No card data', args);
                        return;
                    }

                    document.querySelectorAll('[data-uid="'+args.data[0].id+'"]').forEach(card => {
                        console.log(card);
                        let oldCardHeader = card.parentElement.getAttribute('aria-label');
                        console.log('old card header', oldCardHeader);
                        if(oldCardHeader !== newStatus){
                            card.parentElement.remove();
                        }
                    });

                    // Build updated card object
                    let updatedCard = { ...self.tempCardData, Status: newStatus, swimlaneColumn:newSwimLane };
                    self.tempCardData = updatedCard;
                    self.cardToUpdate = updatedCard;

                    self.cardMovedMethod(args, updatedCard);
                };

                kanbanConfig.toolbarSettings = {
                    items: ['Add']
                };


                self.kanban = new Kanban(kanbanConfig);
                self.kanban.appendTo('#kanban-container');
                self.cardSize(this.layoutSetting.cardSize);
                // ✅ Step 7: Optional swimlane label cleanup (for prefixed keys)
                setTimeout(() => {
                    let safeHeaders = self.swimlaneRow.map(row => ({
                        key: row.key,
                        text: row.text
                    }));
                    document.querySelectorAll('.e-item-count').forEach(header => {
                        header.innerHTML = header.innerHTML.replace('-', '');
                    });

                    let rowMap = {};
                    safeHeaders.forEach(r => {
                        rowMap[r.key] = r.text;
                    });

                    document.querySelectorAll('.e-swimlane-row td .e-swimlane-text').forEach(el => {
                        let original = el.textContent.trim();
                        let matched = Object.entries(rowMap).find(([key]) => original.includes(key));
                        if (matched) {
                            el.textContent = matched[1];
                        }
                    });

                    let dummyCards = [...document.querySelectorAll('.e-card[data-id*="__dummy__"]'), ...document.querySelectorAll('.e-card[data-id*="__DUMMY__"]'), ...document.querySelectorAll('.e-card[data-id*="undefined"]')];

                    dummyCards.forEach(card => {
                        let columnCell = card.closest('.e-content-cells');
                        card.remove(); // 👋 remove dummy card

                        // 🧠 Check if this column has no other real cards
                        let hasRealCards = columnCell.querySelectorAll('.e-card').length > 0;
                        let alreadyHasEmpty = columnCell.querySelector('.e-empty-card');

                        if (!hasRealCards && !alreadyHasEmpty) {
                            let emptyMessage = document.createElement('span');
                            emptyMessage.className = 'e-empty-card';
                            emptyMessage.setAttribute('role', 'option');
                            emptyMessage.setAttribute('aria-label', 'No cards to display');
                            emptyMessage.textContent = 'No cards to display';

                            columnCell.querySelector('.e-card-wrapper')?.appendChild(emptyMessage);
                        }
                    });

                    let contentRows = document.querySelectorAll('.e-kanban .e-content-row:not(.e-swimlane-row)');


                    contentRows.forEach((row, rowIndex) => {
                        let contentCells = row.querySelectorAll('.e-content-cells');

                        contentCells.forEach(cell => {
                            // Prevent duplicate buttons
                            if (cell.querySelector('.kanban-add-task-btn')) return;

                            // Extract the keyField from the column
                            let columnKey = cell.getAttribute('data-key');

                            // Fallback swimlane key logic from row index
                            let swimlaneKey = null;
                            if (this.swimlaneRow && this.swimlaneRow.length > rowIndex) {
                                swimlaneKey = this.swimlaneRow[rowIndex]?.key;
                            }

                            let addBtn = document.createElement('button');
                            addBtn.className = 'kanban-add-task-btn';
                            addBtn.textContent = '+ Add Project';
                            addBtn.onclick = () => {
                                let tempSelectList = [];
                                switch(self.selectedGroupBy.id){
                                    case 'sales_status_code':
                                        tempSelectList = self.selects.sales_status;
                                        break;
                                    default:
                                        tempSelectList = self.selects[self.selectedGroupBy.id];
                                        break;
                                }
                                let columnOBJ = tempSelectList.find(item => item.code === columnKey);

                                let subGroupSwimlaneTempOptionsArray = [
                                    'contract_type',
                                    'client_profile',
                                    'lead_from',
                                    'marketing_status',
                                    'office',
                                    'products_and_services',
                                    'estimator_id',
                                    'take_off_person_id',
                                    'account_manager_id',
                                ];
                                if(self.selectedSubgroupBy && subGroupSwimlaneTempOptionsArray.includes(self.selectedSubgroupBy.property_name)){
                                    let tempSubgroupBy = (self.selectedSubgroupBy)? self.selectedSubgroupBy:null;
                                    if(swimlaneKey && tempSubgroupBy){
                                        let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                                        console.log('###########33', tempSwimlaneKey, tempSubgroupBy);
                                      let filteredSwimlaneKey = null;
                                        if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                                            filteredSwimlaneKey = self.selects['users'].find(item => item.name === tempSwimlaneKey);
                                        }else{
                                            filteredSwimlaneKey =  self.selects[tempSubgroupBy.property_name].find(item => item.code === tempSwimlaneKey);
                                        }
                                        if(filteredSwimlaneKey){
                                            swimlaneKey = filteredSwimlaneKey.id;
                                        }
                                    }
                                    localStorage.setItem('kanban-row', swimlaneKey);
                                  if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                                    localStorage.setItem('kanban-sub-group-by', (this.selectedSubgroupBy)? this.selectedSubgroupBy.property_name:null);
                                  }else{

                                    localStorage.setItem('kanban-sub-group-by', (this.selectedSubgroupBy)? this.selectedSubgroupBy.property_name+'_id':null);
                                  }
                                }else{
                                    localStorage.setItem('kanban-row', null);
                                    localStorage.setItem('kanban-sub-group-by', null);
                                }


                                localStorage.setItem('kanban-group-by', (this.selectedGroupBy.id === 'sales_status_code')? 'sales_status_id': this.selectedGroupBy.id+'_id');
                                localStorage.setItem('kanban-column', (columnOBJ)? columnOBJ.id:null);


                                window.location.href = '/project/create';
                                console.log('Add Task for:', {
                                    columnKey,
                                    swimlaneKey
                                });

                                // openTaskModal({ status: columnKey, swimlane: swimlaneKey });
                            };

                            let wrapper = document.createElement('div');
                            wrapper.className = 'kanban-add-wrapper';
                            wrapper.appendChild(addBtn);


                            cell.appendChild(wrapper);
                        });
                    });

                    let contentWrapper = document.querySelectorAll('.e-kanban .e-content-row:not(.e-swimlane-row) .e-card-wrapper');
                    document.querySelectorAll('.kanban-load-more-btn').forEach(loadMoreButton => {
                        loadMoreButton.remove();
                    });
                    contentWrapper.forEach((row, rowIndex) => {
                            let cards =row.querySelectorAll('.e-draggable');
                            let cardCount = cards.length;
                            let wrapper = document.createElement('div');
                            if (row.querySelector('.kanban-add-task-btn')) return;
                            let columnKey = row.getAttribute('aria-label');
                            let swimlaneKey = '';
                            if (this.swimlaneRow && this.swimlaneRow.length > rowIndex) {
                                swimlaneKey = this.swimlaneRow[rowIndex]?.key;
                            }
                            let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                            // if(self.selectedSubgroupBy){
                            //     let tempSubgroupBy = (self.selectedSubgroupBy)? self.selectedSubgroupBy:null;
                            //     if(swimlaneKey && tempSubgroupBy){
                            //         let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                            //         console.log('###########33', tempSwimlaneKey, tempSubgroupBy);
                            //         let filteredSwimlaneKey = null;
                            //         // if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                            //         //     filteredSwimlaneKey = self.selects['users'].find(item => item.name === tempSwimlaneKey);
                            //         // }else{
                            //         //     filteredSwimlaneKey =  self.selects[tempSubgroupBy.property_name].find(item => item.code === tempSwimlaneKey);
                            //         // }
                            //         // if(filteredSwimlaneKey){
                            //         //     swimlaneKey = filteredSwimlaneKey.id;
                            //         // }
                            //     }
                            // }


                            let tempSelectList = [];
                            switch(self.selectedGroupBy.id){
                                case 'sales_status_code':
                                    tempSelectList = self.selects.sales_status;
                                    break;
                                default:
                                    tempSelectList = self.selects[self.selectedGroupBy.id];
                                    break;
                            }
                            let columnOBJ = tempSelectList.find(item => item.code === columnKey);
                            let columnId = (columnOBJ)? columnOBJ.id:null;

                            let loadMoreBtn = document.createElement('button');
                            loadMoreBtn.className = 'kanban-load-more-btn';
                            loadMoreBtn.textContent = 'Load more projects';
                            loadMoreBtn.onclick = () => {self.loadMoreProjects(columnId, cardCount, tempSwimlaneKey);};
                        wrapper.className = 'loadMoreButtonDiv';
                            wrapper.appendChild(loadMoreBtn);

                        row.appendChild(wrapper);
                    });


                        self.selects.sales_status.forEach(status => {
                            let className = `.status-${status.code.replace(/\s+/g, '-').toLowerCase()}`;

                            let style = document.createElement('style');
                            style.innerHTML = `
                                ${className} {
                                    border-left: 4px solid ${status.color || '#ccc'} !important;
                                }
                            `;
                            document.head.appendChild(style);
                        });
                    // }

                    $('.kanbanCardUserImage').tooltip();
                    $('.projectCommentIcon').tooltip();

                    document.querySelectorAll('.e-header-title').forEach(item => {
                        let columnCellName = item.querySelector('.e-header-text');
                        let columnCellCount = item.querySelector('.e-item-count');
                        let realColumnCardCount = self.dataKanban.filter(
                            card => card.Status.trim() === columnCellName.innerHTML.trim() && !card.isDummy
                        ).length;
                        columnCellCount.textContent = realColumnCardCount+' Item';
                    });


                    document.querySelectorAll('.e-swimlane-row').forEach((row, idx) => {
                        let swimlaneCells = row.querySelectorAll('td');
                        let countSpan = swimlaneCells[0]?.querySelector('.e-item-count');
                        if (!countSpan) return;
                        let swimlaneKey = safeHeaders[idx]?.key;
                        let realCardCount = self.dataKanban.filter(
                            card => card.swimlaneColumn === swimlaneKey && !card.isDummy
                        ).length;
                        countSpan.textContent = realCardCount+' Item(s)';
                    });

                }, 200);

            });
        },
        loadColumns() {
            if (!this.projects.length || !this.selects) return;

            let groupId = this.selectedGroupBy?.id || 'sales_status';
            let groupMap = {
                client_profile: 'client_profile',
                contract_type: 'contract_type',
                lead_from: 'lead_from',
                marketing_status: 'marketing_status',
                office: 'office',
                products_and_services: 'products_and_services',
                sales_status: 'sales_status',
            };

            let groupKey = groupMap[groupId] || 'sales_status';
            let groupItems = [];
            if(groupKey === 'sales_status'){
                groupItems = (this.layoutSetting.hasOwnProperty('salesStatusColumn'))? this.layoutSetting.salesStatusColumn.filter(item => item.checked == 'true'):[];
            }else{
                groupItems = this.selects[groupKey] || [];
            }
            let uniqueCodes = [];
            if(groupItems.length){
                uniqueCodes = Array.from(
                    new Set(groupItems.map(item => item.code).filter(code => code !== null))
                );
            }

            uniqueCodes.push('Unassigned');

            this.columnsKanban = uniqueCodes.map(code => ({
                headerText: code,
                keyField: code,
                allowToggle: true,
                width: 220,
                cssClass: 'scrollable-column',
            }));

            this.dataKanban = this.projects;
            this.tempCardValue = null;
            this.tempCardData = null;
            this.cardToUpdate = null;
            this.cardUpdateCount = 0;
            this.loadKanban();
        },
        getProjectsKanban(fromWhere = null) {
            this.$nextTick(() => {

                if(this.searchText){
                    this.applyKanbanSearch();
                    return false;
                }

                // this.updateUserKanbanSettings('updateFilters');

                if(!fromWhere){

                    this.showLoader = true;
                    $('.e-kanban-header').remove();
                    $('.e-kanban-content').remove();
                }

                if(fromWhere == 'fromEl' || fromWhere == 'fromUpdateProject' || fromWhere == 'fromCardFailure'){
                    this.projectToFetch = 100;
                    this.projectToSkip = 0;
                }
                let userIds = [];
                if (this.selectedUser.length > 0) {
                    this.selectedUser.forEach(item => {
                        userIds.push(item.id);
                    });
                }

                if(!this.selectedGroupBy){
                    let latestSalesStatus = this.groupByOptions.filter(item => {
                        if(item.id === 'sales_status_code') {
                            return item;
                        }
                    })
                    let newName = latestSalesStatus[0].name;

                    this.selectedGroupBy = {
                        id: 'sales_status_code',
                        name: newName
                    };


                }
                if(fromWhere){
                    let el = document.getElementById('kanban-container');
                    this.showKanbanLoader = true;
                    el.style.opacity = '0.3';
                    el.style.filter = 'blur(2px)';
                    el.style.transition = 'opacity 0.5s ease-out';
                }

                let param = {
                    users: userIds,
                    groupBy: this.selectedGroupBy?.id || 'sales_status_code',
                    subgroupBy: this.selectedSubgroupBy ?? null,
                    cardFields: this.layoutSetting.allProjectFieldsForCards,
                    comment: this.layoutSetting.comment,
                    sortColumn: this.layoutSetting.sortColumn,
                    sortDirection: this.layoutSetting.sortDirection,
                    projectToFetch: this.projectToFetch,
                    columnToFetchDataFor: this.columnToFetchDataFor,
                    projectToSkip: this.projectToSkip,
                };

                axios.post(route('project.listing-kanban'), param).then(({data}) => {

                    this.showLoader = false;
                    this.searchText = null;
                    if(fromWhere !== 'loadMore'){
                        this.projects = data.data;
                    }else{
                        if(data.data.length > 0){
                            this.projects = data.data;
                        }
                    }
                    this.swimlaneRow = data.swimlaneRow;
                    this.keysForSearch = data.keysForSearch;

                    if(fromWhere){
                        let self = this;
                        let safeHeaders = self.swimlaneRow.map(row => ({
                            key: row.key,
                            text: row.text
                        }));
                        let tempData = self.projects.map(item => {
                            let originalKey = item.swimlaneColumn;
                            let prefixedRow = safeHeaders.find(r => r.key.endsWith(`_${originalKey}`));
                            return {
                                ...item,
                                swimlaneColumn: prefixedRow?.key || 'Unassigned',
                                swimlaneColumnOld: prefixedRow?.key || 'Unassigned',
                                account_manager_name: item.account_manager_name?.trim() || 'No Account Manager'
                            };
                        });
                        if(fromWhere === 'loadMore' && tempData.length > 0 && data.data.length > 0){
                            self.dataKanban = [...self.dataKanban,...tempData];
                        }else if(tempData.length > 0 && data.data.length > 0){
                            self.dataKanban = tempData;
                        }

                        let existingSwimlaneKeys = new Set(self.dataKanban.map(card => card.swimlaneColumn));
                        safeHeaders.forEach(row => {
                          console.log(!existingSwimlaneKeys.has(row.key), row.key, row);
                            if (!existingSwimlaneKeys.has(row.key)) {
                                self.dataKanban.push({
                                    id: `__dummy__${row.key}`,
                                    Status: self.columnsKanban[0]?.keyField || 'Open',
                                    name: '__DUMMY__',
                                    swimlaneColumn: row.key,
                                    isDummy: true
                                });
                            }
                        });
                        let kanbanInstance = document.querySelector('#kanban-container').ej2_instances[0];

                        if (self.selectedSubgroupBy) {
                            kanbanInstance.swimlaneKey = 'swimlaneColumn';
                            kanbanInstance.swimlaneSettings = {
                                keyField: 'swimlaneColumn',
                                showEmptyRow: true,
                                showItemCount: true,
                                allowToggle: true,
                                headers: safeHeaders
                            };


                            let subGroupSwimlaneTempOptionsArray = [
                              'contract_type',
                              'client_profile',
                              'lead_from',
                              'marketing_status',
                              'office',
                              'products_and_services',
                              'estimator_id',
                              'take_off_person_id',
                              'account_manager_id',
                            ];
                            if(subGroupSwimlaneTempOptionsArray.includes(self.selectedSubgroupBy.property_name)){
                              kanbanInstance.swimlaneSettings.allowDragAndDrop = true;
                            }else{
                                kanbanInstance.swimlaneSettings.allowDragAndDrop = false;
                            }

                        }else{
                            kanbanInstance.swimlaneKey = '';
                            kanbanInstance.swimlaneSettings.keyField = undefined;
                            kanbanInstance.swimlaneSettings.allowDragAndDrop = false;

                        }

                        if(fromWhere === 'loadMore' && tempData.length > 0 && data.data.length > 0){
                            console.log(tempData);
                            kanbanInstance.dataSource = [...self.dataKanban,...tempData];
                            // self.dataKanban = [...self.dataKanban,...tempData];
                            this.columnToFetchDataFor = null;
                        }else if(tempData.length > 0 && data.data.length > 0){
                            // self.dataKanban = tempData;
                            kanbanInstance.dataSource = self.dataKanban;
                        }
                        document.querySelectorAll('.e-item-count').forEach(header => {
                            header.innerHTML = header.innerHTML.replace('-', '');
                        });
                        let el = document.getElementById('kanban-container');



                        setTimeout(() => {
                            let rowMap = {};
                            safeHeaders.forEach(r => {
                                rowMap[r.key] = r.text;
                            });


                            document.querySelectorAll('.e-swimlane-row td .e-swimlane-text').forEach(el => {
                                let original = el.textContent.trim();
                                let matched = Object.entries(rowMap).find(([key]) => original.includes(key));
                                if (matched) {
                                    el.textContent = matched[1];
                                }
                            });

                            document.querySelectorAll('.e-item-count').forEach(header => {
                                header.innerHTML = header.innerHTML.replace('-', '');
                            });



                            let dummyCards = [...document.querySelectorAll('.e-card[data-id*="__dummy__"]'), ...document.querySelectorAll('.e-card[data-id*="__DUMMY__"]'), ...document.querySelectorAll('.e-card[data-id*="undefined"]')];

                            dummyCards.forEach(card => {
                                let columnCell = card.closest('.e-content-cells');
                                card.remove(); // 👋 remove dummy card

                                // 🧠 Check if this column has no other real cards
                                let hasRealCards = columnCell.querySelectorAll('.e-card').length > 0;
                                let alreadyHasEmpty = columnCell.querySelector('.e-empty-card');

                                if (!hasRealCards && !alreadyHasEmpty) {
                                    let emptyMessage = document.createElement('span');
                                    emptyMessage.className = 'e-empty-card';
                                    emptyMessage.setAttribute('role', 'option');
                                    emptyMessage.setAttribute('aria-label', 'No cards to display');
                                    emptyMessage.textContent = 'No cards to display';

                                    columnCell.querySelector('.e-card-wrapper')?.appendChild(emptyMessage);
                                }
                            });

                            let contentRows = document.querySelectorAll('.e-kanban .e-content-row:not(.e-swimlane-row)');

                            contentRows.forEach((row, rowIndex) => {
                                let contentCells = row.querySelectorAll('.e-content-cells');

                                contentCells.forEach(cell => {
                                    // Prevent duplicate buttons
                                    if (cell.querySelector('.kanban-add-task-btn')) return;

                                    // Extract the keyField from the column
                                    let columnKey = cell.getAttribute('data-key');

                                    // Fallback swimlane key logic from row index
                                    let swimlaneKey = null;
                                    if (this.swimlaneRow && this.swimlaneRow.length > rowIndex) {
                                        swimlaneKey = this.swimlaneRow[rowIndex]?.key;
                                    }

                                    let addBtn = document.createElement('button');
                                    addBtn.className = 'kanban-add-task-btn';
                                    addBtn.textContent = '+ Add Project';
                                    addBtn.onclick = () => {
                                        let tempSelectList = [];
                                        switch(self.selectedGroupBy.id){
                                            case 'sales_status_code':
                                                tempSelectList = self.selects.sales_status;
                                                break;
                                            default:
                                                tempSelectList = self.selects[self.selectedGroupBy.id];
                                                break;
                                        }
                                        let columnOBJ = tempSelectList.find(item => item.code === columnKey);

                                        let subGroupSwimlaneTempOptionsArray = [
                                            'contract_type',
                                            'client_profile',
                                            'lead_from',
                                            'marketing_status',
                                            'office',
                                            'products_and_services',
                                            'estimator_id',
                                            'take_off_person_id',
                                            'account_manager_id',
                                        ];
                                        if(self.selectedSubgroupBy && subGroupSwimlaneTempOptionsArray.includes(self.selectedSubgroupBy.property_name)){
                                            let tempSubgroupBy = (self.selectedSubgroupBy)? self.selectedSubgroupBy:null;
                                            if(swimlaneKey && tempSubgroupBy){
                                                let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                                                console.log('###########33', tempSwimlaneKey, tempSubgroupBy);
                                                let filteredSwimlaneKey = null;
                                                if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                                                    filteredSwimlaneKey = self.selects['users'].find(item => item.name === tempSwimlaneKey);
                                                }else{
                                                    filteredSwimlaneKey =  self.selects[tempSubgroupBy.property_name].find(item => item.code === tempSwimlaneKey);
                                                }
                                                if(filteredSwimlaneKey){
                                                    swimlaneKey = filteredSwimlaneKey.id;
                                                }
                                            }
                                            localStorage.setItem('kanban-row', swimlaneKey);
                                            if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                                                localStorage.setItem('kanban-sub-group-by', (this.selectedSubgroupBy)? this.selectedSubgroupBy.property_name:null);
                                            }else{

                                                localStorage.setItem('kanban-sub-group-by', (this.selectedSubgroupBy)? this.selectedSubgroupBy.property_name+'_id':null);
                                            }
                                        }else{
                                            localStorage.setItem('kanban-row', null);
                                            localStorage.setItem('kanban-sub-group-by', null);
                                        }


                                        localStorage.setItem('kanban-group-by', (this.selectedGroupBy.id === 'sales_status_code')? 'sales_status_id': this.selectedGroupBy.id+'_id');
                                        localStorage.setItem('kanban-column', (columnOBJ)? columnOBJ.id:null);


                                        window.location.href = '/project/create';
                                        console.log('Add Task for:', {
                                            columnKey,
                                            swimlaneKey
                                        });

                                        // openTaskModal({ status: columnKey, swimlane: swimlaneKey });
                                    };

                                    let wrapper = document.createElement('div');
                                    wrapper.className = 'kanban-add-wrapper';
                                    wrapper.appendChild(addBtn);

                                    cell.appendChild(wrapper);
                                });
                            });

                            let contentWrapper = document.querySelectorAll('.e-kanban .e-content-row:not(.e-swimlane-row) .e-card-wrapper');
                            document.querySelectorAll('.kanban-load-more-btn').forEach(loadMoreButton => {
                                loadMoreButton.remove();
                            });
                            contentWrapper.forEach((row, rowIndex) => {
                                let cards =row.querySelectorAll('.e-draggable');
                                let cardCount = cards.length;
                                let wrapper = document.createElement('div');
                                if (row.querySelector('.kanban-add-task-btn')) return;
                                let columnKey = row.getAttribute('aria-label');
                                let swimlaneKey = '';
                                if (this.swimlaneRow && this.swimlaneRow.length > rowIndex) {
                                    swimlaneKey = this.swimlaneRow[rowIndex]?.key;
                                }
                                let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                                // if(self.selectedSubgroupBy){
                                //     let tempSubgroupBy = (self.selectedSubgroupBy)? self.selectedSubgroupBy:null;
                                //     if(swimlaneKey && tempSubgroupBy){
                                //         let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                                //         console.log('###########33', tempSwimlaneKey, tempSubgroupBy);
                                //         let filteredSwimlaneKey = null;
                                //         // if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                                //         //     filteredSwimlaneKey = self.selects['users'].find(item => item.name === tempSwimlaneKey);
                                //         // }else{
                                //         //     filteredSwimlaneKey =  self.selects[tempSubgroupBy.property_name].find(item => item.code === tempSwimlaneKey);
                                //         // }
                                //         // if(filteredSwimlaneKey){
                                //         //     swimlaneKey = filteredSwimlaneKey.id;
                                //         // }
                                //     }
                                // }


                                let tempSelectList = [];
                                switch(self.selectedGroupBy.id){
                                    case 'sales_status_code':
                                        tempSelectList = self.selects.sales_status;
                                        break;
                                    default:
                                        tempSelectList = self.selects[self.selectedGroupBy.id];
                                        break;
                                }
                                let columnOBJ = tempSelectList.find(item => item.code === columnKey);
                                let columnId = (columnOBJ)? columnOBJ.id:null;

                                let loadMoreBtn = document.createElement('button');
                                loadMoreBtn.className = 'kanban-load-more-btn';
                                loadMoreBtn.textContent = 'Load more projects';
                                loadMoreBtn.onclick = () => {self.loadMoreProjects(columnId, cardCount, tempSwimlaneKey);};
                                wrapper.className = 'loadMoreButtonDiv';
                                wrapper.appendChild(loadMoreBtn);


                                    row.appendChild(wrapper);

                            });

                            // if(self.selectedGroupBy && self.selectedGroupBy.id === 'sales_status_code'){
                            //     let cards = document.querySelectorAll('.e-kanban .e-card');
                            //         console.log(cards);
                            //     cards.forEach(card => {
                            //         let statusKey = card.getAttribute('data-key');
                            //         if (statusKey) {
                            //             let statusClass = `status-${statusKey.replace(/\s+/g, '-').toLowerCase()}`;
                            //             card.classList.add(statusClass);
                            //         }
                            //     });

                            self.selects.sales_status.forEach(status => {
                                let className = `.status-${status.code.replace(/\s+/g, '-').toLowerCase()}`;

                                let style = document.createElement('style');
                                style.innerHTML = `
                                ${className} {
                                    border-left: 4px solid ${status.color || '#ccc'} !important;
                                }
                            `;
                                document.head.appendChild(style);
                            });
                            // }

                            $('.kanbanCardUserImage').tooltip();
                            $('.projectCommentIcon').tooltip();

                            // document.querySelectorAll('div').forEach(div => {
                            //     // grab the full text inside the div, normalize whitespace & case
                            //     let txt = div.textContent.trim().toLowerCase();
                            //     if (txt.includes('license key is invalid')) {
                            //         div.remove();
                            //     }
                            // });

                            document.querySelectorAll('.e-header-title').forEach(item => {
                                let columnCellName = item.querySelector('.e-header-text');
                                let columnCellCount = item.querySelector('.e-item-count');
                                let realColumnCardCount = self.dataKanban.filter(
                                    card => card.Status.trim() === columnCellName.innerHTML.trim() && !card.isDummy
                                ).length;
                                columnCellCount.textContent = realColumnCardCount+' Item';
                            });

                            document.querySelectorAll('.e-swimlane-row').forEach((row, idx) => {
                                let swimlaneCells = row.querySelectorAll('td');
                                // Debug: should be 1 cell per row
                                console.log(swimlaneCells);

                                // Find the item count span inside the first (and only) cell
                                let countSpan = swimlaneCells[0]?.querySelector('.e-item-count');

                                if (!countSpan) return;

                                // Figure out the swimlane key for this row
                                let swimlaneKey = safeHeaders[idx]?.key;

                                // Count non-dummy cards for this swimlane
                                let realCardCount = self.dataKanban.filter(
                                    card => card.swimlaneColumn === swimlaneKey && !card.isDummy
                                ).length;

                                // Set the correct count
                                countSpan.textContent = realCardCount+' Item(s)';
                            });


                        }, 200);

                        requestAnimationFrame(() => {
                            el.style.opacity = '1';
                            el.style.filter = 'blur(0)';
                            el.style.transition = 'opacity 1s ease-in';
                        });
                        this.showKanbanLoader = false;
                        return false;
                    }

                    this.$nextTick(() => {
                        this.loadColumns();
                    });
                });
            });
        },
        getKanbanGroupAndSubgroupFields() {
            axios.post(route('project.kanban-fields')).then(({data}) => {
                this.groupByOptions = data.groupFields;
                this.subgroupByOptions = data.subgroupFields;
                let latestSalesStatus = this.groupByOptions.filter(item => {
                    if(item.id === 'sales_status_code') {
                        return item;
                    }
                })
                this.selectedGroupBy.name = latestSalesStatus[0].name;
                this.showFilters = true;
                if(this.filters && this.filters.hasOwnProperty('subgroupBy')){
                    let subOption = this.subgroupByOptions.find(item => {
                        console.log(item, this.filters.subgroupBy);
                        return item.property_name
                            ? item.property_name === this.filters.subgroupBy?.property_name
                            : item.slug === this.filters.subgroupBy?.slug;
                    });
                    if(subOption && subOption !== 'undefined'){
                        this.filters.subgroupBy.id = subOption.id;
                    }
                }
                this.getProjectsKanban();
            });
        },
        cardMovedMethod(args) {

            // if(this.cardUpdateCount == 1){
            //     return;
            // }

            // try {
            //     console.log('Card data:', args.data);
            // } catch (e) {
            //     console.warn('Failed to log card data:', e);
            // }

            this.cardUpdateCount = 1;
            let cardData = this.tempCardData;
            // this.tempCardData = cardData;
            console.log(cardData, '===============================================');
            this.$nextTick(() => {
                let checkMap = {
                    sales_status_code: this.salesStatusCheck,
                    // client_profile: this.genericCheck.bind(this, 'client_profile'),
                    // contract_type: this.genericCheck.bind(this, 'contract_type'),
                    // lead_from: this.genericCheck.bind(this, 'lead_from'),
                    // marketing_status: this.genericCheck.bind(this, 'marketing_status'),
                    // office: this.genericCheck.bind(this, 'office'),
                    // products_and_services: this.genericCheck.bind(this, 'products_and_services')
                };


              let matchedStatusValue = null;
                let originalData = this.projects.filter(item => item.id === cardData.id);
                    console.log(!this.selectedSubgroupBy && cardData.sales_statuses_code !== cardData.Status, this.selectedSubgroupBy,cardData.sales_statuses_code,cardData.Status);
                if (!this.selectedSubgroupBy && cardData.sales_statuses_code !== cardData.Status) {
                    let checker = checkMap[this.selectedGroupBy.id];
                    if (checker) {
                        let requiredCheck = checker(cardData);
                        console.log('#########################', requiredCheck);
                        if(requiredCheck){
                            return false;
                        }
                    }
                  matchedStatusValue = this.selects.sales_status.find(item => item.code === cardData.Status);
                    console.log('++++++++++++++++++++++++++', cardData.Status, matchedStatusValue);
                  this.tempCardValue = matchedStatusValue;
                    this.updateProject();
                }else if(this.selectedSubgroupBy && originalData.length > 0 && cardData.swimlaneColumn !== originalData[0].swimlaneColumn){
                  console.log('#########################', cardData.swimlaneColumn, cardData.swimlaneColumnOld);
                  if(cardData.sales_statuses_code !== cardData.Status && cardData.swimlaneColumn !== cardData.swimlaneColumnOld){
                    console.log('#########################', cardData.sales_statuses_code , cardData.Status);
                    let checker = checkMap[this.selectedGroupBy.id];
                    if (checker) {
                        let requiredCheck = checker(cardData);
                        console.log('#########################', requiredCheck);
                        if(requiredCheck){
                            return false;
                        }
                    }

                    matchedStatusValue = this.selects.sales_status.find(item => item.code === cardData.Status);
                    console.log('++++++++++++++++++++++++++', cardData.Status, matchedStatusValue);
                    this.tempCardValue = matchedStatusValue;
                    this.updateProject();
                  }
                    console.log('++++++++++++++++++++++++++', cardData.Status, matchedStatusValue);
                  if(cardData.swimlaneColumn !== cardData.swimlaneColumnOld){
                      let checker = checkMap[this.selectedGroupBy.id];
                      if (checker) {
                          let requiredCheck = checker(cardData);
                          console.log('#########################', requiredCheck);
                          if(requiredCheck){
                              return false;
                          }
                      }
                    matchedStatusValue = this.selects.sales_status.find(item => item.code === cardData.Status);
                    console.log('++++++++++++++++++++++++++', cardData.Status, matchedStatusValue);
                    this.tempCardValue = matchedStatusValue;
                    this.updateProject();
                  }

                  if(cardData.sales_statuses_code !== cardData.Status){
                      let checker = checkMap[this.selectedGroupBy.id];
                      if (checker) {
                          let requiredCheck = checker(cardData);
                          console.log('#########################', requiredCheck);
                          if(requiredCheck){
                              return false;
                          }
                      }
                    matchedStatusValue = this.selects.sales_status.find(item => item.code === cardData.Status);
                    console.log('++++++++++++++++++++++++++', cardData.Status, matchedStatusValue);
                    this.tempCardValue = matchedStatusValue;
                    this.updateProject();
                  }
                }
                setTimeout(() => {
                    let self = this;
                    document.querySelectorAll('.e-item-count').forEach(header => {
                        header.innerHTML = header.innerHTML.replace('-', '');
                    });

                    let safeHeaders = this.swimlaneRow.map(row => ({
                        key: row.key,
                        text: row.text
                    }));
                    let rowMap = {};
                    safeHeaders.forEach(r => {
                        rowMap[r.key] = r.text;
                    });

                    document.querySelectorAll('.e-swimlane-row td .e-swimlane-text').forEach(el => {
                        let original = el.textContent.trim();
                        let matched = Object.entries(rowMap).find(([key]) => original.includes(key));
                        if (matched) {
                            el.textContent = matched[1];
                        }
                    });

                    $('.kanbanCardUserImage').tooltip();
                    $('.projectCommentIcon').tooltip();

                    document.querySelectorAll('.e-header-title').forEach(item => {
                        let columnCellName = item.querySelector('.e-header-text');
                        let columnCellCount = item.querySelector('.e-item-count');
                        let realColumnCardCount = self.dataKanban.filter(
                            card => card.Status.trim() === columnCellName.innerHTML.trim() && !card.isDummy
                        ).length;
                        columnCellCount.textContent = realColumnCardCount+' Item';
                    });

                    document.querySelectorAll('.e-swimlane-row').forEach((row, idx) => {
                        let swimlaneCells = row.querySelectorAll('td');
                        let countSpan = swimlaneCells[0]?.querySelector('.e-item-count');
                        if (!countSpan) return;
                        let swimlaneKey = safeHeaders[idx]?.key;
                        let realCardCount = self.dataKanban.filter(
                            card => card.swimlaneColumn === swimlaneKey && !card.isDummy
                        ).length;
                        countSpan.textContent = realCardCount+' Item(s)';
                    });

                }, 200);
                this.cardUpdateCount = 0;
            });
        },
        salesStatusCheck(cardData) {
            // if (cardData.Status !== cardData.sales_statuses_code) {
                let matched = this.selects.sales_status.find(item => item.code === cardData.Status);
                this.tempCardValue = matched;

                if (matched?.comment) {
                    this.projectCommentForm.project_id = cardData.id;
                    this.projectCommentForm.sales_status = matched;
                    this.projectCommentForm.sales_status_id = matched.id;
                    this.addComment();
                    return true;
                }

                if(matched?.contract && (cardData.contract_amount == null || cardData.contract_amount == 0 || cardData.contract_amount == 0.00 || cardData.contract_amount == undefined)){
                    let message = "<p>Add contract amount to change the Sales Status to Contract</p>";
                    this.popupForChangingSalesStatus(message, cardData);
                    return true;
                }
                return false;
                // this.updateProject();
            // }
        },
        genericCheck(selectKey, cardData) {
            let selectList = this.selects[selectKey];
            if (Array.isArray(selectList)) {
                this.tempCardValue = selectList.find(item => item.code === cardData.Status);
            }
        },
        updateProject(){
          $(`[data-project-uid="${this.cardToUpdate.id}"]`).each(function() {
            $(this).parent().css('pointer-events', 'none');
          });
            let userIds = [];
            if (this.selectedUser.length > 0) {
                this.selectedUser.forEach(item => {
                    userIds.push(item.id);
                });
            }
            let payload = {
                groupByObj: this.selectedGroupBy,
                groupBy: this.selectedGroupBy?.id || 'sales_status_code',
                subgroupBy: this.selectedSubgroupBy ?? null,
                // cardData: this.tempCardData,
                cardData: this.cardToUpdate,
                value: this.tempCardValue,
                users: userIds,
                cardFields: this.layoutSetting.allProjectFieldsForCards,
                comment: this.layoutSetting.comment,
                sortColumn: this.layoutSetting.sortColumn,
                sortDirection: this.layoutSetting.sortDirection,
            }

            // this.$nextTick(() => {
                if(this.selectedSubgroupBy){
                    payload.cardData.swimlaneColumn = this.cardToUpdate.swimlaneColumn;
                    console.log(this.cardToUpdate.swimlaneColumn, payload.cardData.swimlaneColumn);
                }
                let el = document.getElementById('kanban-container');
                this.showKanbanLoader = true;
                el.style.opacity = '0.3';
                el.style.filter = 'blur(2px)';
                el.style.transition = 'opacity 0.5s ease-out';
                axios.post(route('kanban-project-update'), payload).then(response => {

                    if (response.data.status =='success') {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });

                        this.getProjectsKanban('fromUpdateProject');
                        return false;
                    }else{
                        this.getToast(5000).fire({
                            type: 'error',
                            title: "Required field must be updated in order to update this field.\nPlease drill into the project to update."
                        });

                        this.getProjectsKanban('fromCardFailure');

                    }
                }).catch(error => {
                    this.getToast(5000).fire({
                        type: 'error',
                        title: "Required field must be updated in order to update this field.\nPlease drill into the project to update."
                    });
                    this.getProjectsKanban('fromCardFailure');
                })
            // });

        },
        buildKanbanCardWrapper(project) {
            let wrapper = document.createElement('div');
            wrapper.className = 'e-card e-template e-droppable e-lib e-draggable';
            wrapper.setAttribute('data-id', project.id);
            wrapper.setAttribute('data-key', project.Status);
            wrapper.setAttribute('tabindex', '-1');
            wrapper.setAttribute('role', 'option');
            wrapper.setAttribute('aria-roledescription', 'Card');
            wrapper.setAttribute('data-uid', `card_${project.id}`);
            wrapper.setAttribute('aria-selected', 'false');
            wrapper.setAttribute('aria-grabbed', 'false');
            wrapper.innerHTML = project.cardTemplate;
            return wrapper;
        },
        appendWrappedCardToKanban(project, swimlaneKey = null) {
            let columnCell = document.querySelector(`.e-content-cells[data-key="${project.Status}"]`);
            if (!columnCell) return;

            let cardWrapperContainer = null;
            if (swimlaneKey) {
                cardWrapperContainer = columnCell.querySelector(`.e-card-wrapper[data-swimlane-key="${swimlaneKey}"]`)
                    || columnCell.querySelector(`.e-card-wrapper[data-key="${swimlaneKey}"]`);
            }
            if (!cardWrapperContainer) {
                cardWrapperContainer = columnCell.querySelector('.e-card-wrapper');
                if (!cardWrapperContainer) return;
            }

            let cardDiv = this.buildKanbanCardWrapper(project);
            cardWrapperContainer.appendChild(cardDiv);
        },
        addComment() {
            $("#projectCommentModal").modal("show");
        },
        projectCommentSaved(from = null) {
            let self = this;
            if(!self.projectCommentForm.comment || self.projectCommentForm.comment == ''){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please add text to comment'
                })
                return;
            }
            self.projectCommentForm.saving = true;
            let tempProjectId = self.projectCommentForm.project_id
            self.projectCommentForm.post(route('api.project-comment.store', {project: self.projectCommentForm.project_id})).then((res) => {
                self.projectCommentForm.saving = false;
                self.checkCommentStatus = self.projectCommentForm.project_id;
                $("#projectCommentModal").modal("hide");
                self.projectCommentForm.reset();
                self.projectCommentForm.project_id = tempProjectId;
                if(!from){
                    self.updateProject();
                }else{
                    self.getToast().fire({
                        type: 'success',
                        title: 'Comment Saved'
                    })
                    if(from === 'projectCommentModalSaveAndClose'){
                        self.closeProjectCommentSectionModal();
                    }else{
                        self.getPanelProjectData();
                    }
                }
            });

        },
        closeProjectCommentModal() {
          if (document.activeElement) {
            document.activeElement.blur();
          }

          setTimeout(() => {
            $("#projectCommentModal").modal("hide");
            this.getProjectsKanban();
            this.projectCommentForm.reset();
          }, 50);
        },
        addMention(replaced) {
            if (_.find(this.projectCommentForm.mentioned_users, o => o === replaced.id)) {
                return;
            }
            this.projectCommentForm.mentioned_users.push(replaced.id);
        },
        getPanelProjectData(){
            this.$nextTick(() => {
                this.loadProjectForComment = false;
                axios.post(route('kanban-panel-project'), {id: this.tempCardData.id}).then(({data}) => {
                    this.projectQuickViewData = data.project;
                    this.loadProjectForComment = true;
                });
            });
        },
        popupForChangingSalesStatus(html, project) {
            let self = this;

            Swal.fire({
                icon: 'warning',
                title: 'Warning!',
                html: html,
                showCancelButton: true,
                confirmButtonColor: '#4dc0b5',
                confirmButtonText: 'Go To Project',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
            }).then((result) => {
                this.cardUpdateCount = 0;
                if(result.value) {
                    window.location = self.editProject(project);
                }else{
                    this.getProjectsKanban();
                }
            });
        },
        editProject(project) {
            let url = '';
            if (project.id){
                url = route('project.edit', {project: project.id}) + `?project=1`;
            }
            return url;
        },
        closeKanbanProjectQuickView(){
            $('#kanbanProjectQuickView').modal('hide');
            this.projectQuickViewData = null;
            this.isSidePanelOpen = false;
        },
        cardSize(size){
            this.layoutSetting.cardSize = size;
            if(this.layoutSetting.cardSize === 'Small'){
                this.setCellWidth(190, 5);
                return true;
            }else if(this.layoutSetting.cardSize === 'Large'){
                this.setCellWidth(270, 15);
                return true;
            }
            this.setCellWidth(230, 15);

        },
        setCellWidth(width, headerWidth) {
            this.removeAllCellWidthStyles();
            let style = document.createElement('style');
            style.setAttribute('data-cell-width-style', 'true');
            style.innerHTML = `
            .e-header-cells,
            .e-content-cells {
              width: ${width}px !important;
              min-width: ${width}px !important;
              max-width: ${width}px !important;
            }
            .e-kanban .e-kanban-header .e-header-cells .e-header-text {
              width: 100% !important;
              max-width: ${headerWidth}vw !important;
            }
            .e-collapsed {
                width: 100% !important;
                max-width: 85px !important;
                min-width: 85px !important;
            }
            `;
            document.head.appendChild(style);
        },
        removeAllCellWidthStyles() {
            let styles = document.querySelectorAll('style[data-cell-width-style="true"]');
            styles.forEach(style => style.remove());
        },
        updateUserKanbanSettings(forWhat = null){

            this.$nextTick(() => {
                let payload = {
                    filters: {
                        groupBy: this.selectedGroupBy,
                        subgroupBy: this.selectedSubgroupBy,
                        users: this.selectedUser,
                    },
                    layoutSettings: this.layoutSetting,
                    cardFieldSettings: this.cardFieldSetting,
                }

                axios.post(route('kanban-user-setting-update'), payload).then(response => {
                    if (response) {
                        if(forWhat !== 'updateFilters'){
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                            this.isCustomizePanel = false;
                            this.getProjectsKanban('fromEl');
                        }
                    }

                });
            });
        },
        applyKanbanSearch() {

            let self = this;
            self.fullKanbanData = [];
            self.fullKanbanData = JSON.parse(JSON.stringify(self.dataKanban));
            console.log('------', this.searchText);
            if(this.searchText == '' || !this.searchText){
                this.getProjectsKanban('fromEl');

                return false;
            }
            clearTimeout(this.filter.timeout);
            this.filter.loadingData = true;
            this.filter.timeout = setTimeout(() => {
                if (!this.kanban) return;

                let text = this.searchText.trim();

                if (!text || text == '') {
                    this.kanban.dataSource = self.fullKanbanData;
                } else {
                    let searchValue = text.toLowerCase();
                    let el = document.getElementById('kanban-container');
                    this.showKanbanLoader = true;
                    el.style.opacity = '0.3';
                    el.style.filter = 'blur(2px)';
                    el.style.transition = 'opacity 0.5s ease-out';

                    let userIds = [];
                    if (this.selectedUser.length > 0) {
                        this.selectedUser.forEach(item => {
                            userIds.push(item.id);
                        });
                    }

                    let param = {
                        users: userIds,
                        groupBy: this.selectedGroupBy?.id || 'sales_status_code',
                        subgroupBy: this.selectedSubgroupBy ?? null,
                        cardFields: this.layoutSetting.allProjectFieldsForCards,
                        comment: this.layoutSetting.comment,
                        sortColumn: this.layoutSetting.sortColumn,
                        sortDirection: this.layoutSetting.sortDirection,
                        projectToFetch: this.projectToFetch,
                        columnToFetchDataFor: null,
                        keysForSearch: searchValue,
                        projectToSkip: 0,
                    };

                    axios.post(route('project.listing-kanban-search'), param).then(({data}) => {

                        this.showLoader = false;
                        this.projects = data.data;
                        this.swimlaneRow = data.swimlaneRow;
                        this.keysForSearch = data.keysForSearch;

                            let self = this;
                            let safeHeaders = self.swimlaneRow.map(row => ({
                                key: row.key,
                                text: row.text
                            }));
                            let tempData = self.projects.map(item => {
                                let originalKey = item.swimlaneColumn;
                                let prefixedRow = safeHeaders.find(r => r.key.endsWith(`_${originalKey}`));
                                return {
                                    ...item,
                                    swimlaneColumn: prefixedRow?.key || 'Unassigned',
                                    swimlaneColumnOld: prefixedRow?.key || 'Unassigned',
                                    account_manager_name: item.account_manager_name?.trim() || 'No Account Manager'
                                };
                            });
                            let existingSwimlaneKeys = new Set(self.dataKanban.map(card => card.swimlaneColumn));
                            safeHeaders.forEach(row => {
                                if (!existingSwimlaneKeys.has(row.key)) {
                                    self.dataKanban.push({
                                        id: `__dummy__${row.key}`,
                                        Status: self.columnsKanban[0]?.keyField || 'Open',
                                        name: '__DUMMY__',
                                        swimlaneColumn: row.key,
                                        isDummy: true
                                    });
                                }
                            });
                            let kanbanInstance = document.querySelector('#kanban-container').ej2_instances[0];

                                self.dataKanban = tempData;
                                kanbanInstance.dataSource = self.dataKanban;

                            document.querySelectorAll('.e-item-count').forEach(header => {
                                header.innerHTML = header.innerHTML.replace('-', '');
                            });
                            let el = document.getElementById('kanban-container');

                            requestAnimationFrame(() => {
                                el.style.opacity = '1';
                                el.style.filter = 'blur(0)';
                                el.style.transition = 'opacity 0.5s ease-in';
                            });
                            this.showKanbanLoader = false;

                            setTimeout(() => {

                                document.querySelectorAll('.e-item-count').forEach(header => {
                                    header.innerHTML = header.innerHTML.replace('-', '');
                                });

                                let rowMap = {};
                                safeHeaders.forEach(r => {
                                    rowMap[r.key] = r.text;
                                });


                                document.querySelectorAll('.e-swimlane-row td .e-swimlane-text').forEach(el => {
                                    let original = el.textContent.trim();
                                    let matched = Object.entries(rowMap).find(([key]) => original.includes(key));
                                    if (matched) {
                                        el.textContent = matched[1];
                                    }
                                });

                                let dummyCards = [...document.querySelectorAll('.e-card[data-id*="__dummy__"]'), ...document.querySelectorAll('.e-card[data-id*="__DUMMY__"]'), ...document.querySelectorAll('.e-card[data-id*="undefined"]')];

                                dummyCards.forEach(card => {
                                    let columnCell = card.closest('.e-content-cells');
                                    card.remove(); // 👋 remove dummy card

                                    // 🧠 Check if this column has no other real cards
                                    let hasRealCards = columnCell.querySelectorAll('.e-card').length > 0;
                                    let alreadyHasEmpty = columnCell.querySelector('.e-empty-card');

                                    if (!hasRealCards && !alreadyHasEmpty) {
                                        let emptyMessage = document.createElement('span');
                                        emptyMessage.className = 'e-empty-card';
                                        emptyMessage.setAttribute('role', 'option');
                                        emptyMessage.setAttribute('aria-label', 'No cards to display');
                                        emptyMessage.textContent = 'No cards to display';

                                        columnCell.querySelector('.e-card-wrapper')?.appendChild(emptyMessage);
                                    }
                                });

                                let contentRows = document.querySelectorAll('.e-kanban .e-content-row:not(.e-swimlane-row)');

                                contentRows.forEach((row, rowIndex) => {
                                    let contentCells = row.querySelectorAll('.e-content-cells');

                                    contentCells.forEach(cell => {
                                        // Prevent duplicate buttons
                                        if (cell.querySelector('.kanban-add-task-btn')) return;

                                        // Extract the keyField from the column
                                        let columnKey = cell.getAttribute('data-key');

                                        // Fallback swimlane key logic from row index
                                        let swimlaneKey = null;
                                        if (this.swimlaneRow && this.swimlaneRow.length > rowIndex) {
                                            swimlaneKey = this.swimlaneRow[rowIndex]?.key;
                                        }

                                        let addBtn = document.createElement('button');
                                        addBtn.className = 'kanban-add-task-btn';
                                        addBtn.textContent = '+ Add Project';
                                        addBtn.onclick = () => {
                                            let tempSelectList = [];
                                            switch(self.selectedGroupBy.id){
                                                case 'sales_status_code':
                                                    tempSelectList = self.selects.sales_status;
                                                    break;
                                                default:
                                                    tempSelectList = self.selects[self.selectedGroupBy.id];
                                                    break;
                                            }
                                            let columnOBJ = tempSelectList.find(item => item.code === columnKey);

                                            let subGroupSwimlaneTempOptionsArray = [
                                                'contract_type',
                                                'client_profile',
                                                'lead_from',
                                                'marketing_status',
                                                'office',
                                                'products_and_services',
                                                'estimator_id',
                                                'take_off_person_id',
                                                'account_manager_id',
                                            ];
                                            if(self.selectedSubgroupBy && subGroupSwimlaneTempOptionsArray.includes(self.selectedSubgroupBy.property_name)){
                                                let tempSubgroupBy = (self.selectedSubgroupBy)? self.selectedSubgroupBy:null;
                                                if(swimlaneKey && tempSubgroupBy){
                                                    let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                                                    console.log('###########33', tempSwimlaneKey, tempSubgroupBy);
                                                    let filteredSwimlaneKey = null;
                                                    if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                                                        filteredSwimlaneKey = self.selects['users'].find(item => item.name === tempSwimlaneKey);
                                                    }else{
                                                        filteredSwimlaneKey =  self.selects[tempSubgroupBy.property_name].find(item => item.code === tempSwimlaneKey);
                                                    }
                                                    if(filteredSwimlaneKey){
                                                        swimlaneKey = filteredSwimlaneKey.id;
                                                    }
                                                }
                                                localStorage.setItem('kanban-row', swimlaneKey);
                                                if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                                                    localStorage.setItem('kanban-sub-group-by', (this.selectedSubgroupBy)? this.selectedSubgroupBy.property_name:null);
                                                }else{

                                                    localStorage.setItem('kanban-sub-group-by', (this.selectedSubgroupBy)? this.selectedSubgroupBy.property_name+'_id':null);
                                                }
                                            }else{
                                                localStorage.setItem('kanban-row', null);
                                                localStorage.setItem('kanban-sub-group-by', null);
                                            }


                                            localStorage.setItem('kanban-group-by', (this.selectedGroupBy.id === 'sales_status_code')? 'sales_status_id': this.selectedGroupBy.id+'_id');
                                            localStorage.setItem('kanban-column', (columnOBJ)? columnOBJ.id:null);


                                            window.location.href = '/project/create';
                                            console.log('Add Task for:', {
                                                columnKey,
                                                swimlaneKey
                                            });

                                            // openTaskModal({ status: columnKey, swimlane: swimlaneKey });
                                        };

                                        let wrapper = document.createElement('div');
                                        wrapper.className = 'kanban-add-wrapper';
                                        wrapper.appendChild(addBtn);

                                        cell.appendChild(wrapper);
                                    });
                                });

                                let contentWrapper = document.querySelectorAll('.e-kanban .e-content-row:not(.e-swimlane-row) .e-card-wrapper');
                                document.querySelectorAll('.kanban-load-more-btn').forEach(loadMoreButton => {
                                    loadMoreButton.remove();
                                });
                                contentWrapper.forEach((row, rowIndex) => {
                                    let cards =row.querySelectorAll('.e-draggable');
                                    let cardCount = cards.length;
                                    let wrapper = document.createElement('div');
                                    if (row.querySelector('.kanban-add-task-btn')) return;
                                    let columnKey = row.getAttribute('aria-label');
                                    let swimlaneKey = '';
                                    if (this.swimlaneRow && this.swimlaneRow.length > rowIndex) {
                                        swimlaneKey = this.swimlaneRow[rowIndex]?.key;
                                    }
                                    let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                                    // if(self.selectedSubgroupBy){
                                    //     let tempSubgroupBy = (self.selectedSubgroupBy)? self.selectedSubgroupBy:null;
                                    //     if(swimlaneKey && tempSubgroupBy){
                                    //         let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                                    //         console.log('###########33', tempSwimlaneKey, tempSubgroupBy);
                                    //         let filteredSwimlaneKey = null;
                                    //         // if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                                    //         //     filteredSwimlaneKey = self.selects['users'].find(item => item.name === tempSwimlaneKey);
                                    //         // }else{
                                    //         //     filteredSwimlaneKey =  self.selects[tempSubgroupBy.property_name].find(item => item.code === tempSwimlaneKey);
                                    //         // }
                                    //         // if(filteredSwimlaneKey){
                                    //         //     swimlaneKey = filteredSwimlaneKey.id;
                                    //         // }
                                    //     }
                                    // }


                                    let tempSelectList = [];
                                    switch(self.selectedGroupBy.id){
                                        case 'sales_status_code':
                                            tempSelectList = self.selects.sales_status;
                                            break;
                                        default:
                                            tempSelectList = self.selects[self.selectedGroupBy.id];
                                            break;
                                    }
                                    let columnOBJ = tempSelectList.find(item => item.code === columnKey);
                                    let columnId = (columnOBJ)? columnOBJ.id:null;

                                    let loadMoreBtn = document.createElement('button');
                                    loadMoreBtn.className = 'kanban-load-more-btn';
                                    loadMoreBtn.textContent = 'Load more projects';
                                    loadMoreBtn.onclick = () => {self.loadMoreProjects(columnId, cardCount, tempSwimlaneKey);};
                                    wrapper.className = 'loadMoreButtonDiv';
                                    wrapper.appendChild(loadMoreBtn);

                                    row.appendChild(wrapper);
                                });

                                // if(self.selectedGroupBy && self.selectedGroupBy.id === 'sales_status_code'){
                                //     let cards = document.querySelectorAll('.e-kanban .e-card');
                                //         console.log(cards);
                                //     cards.forEach(card => {
                                //         let statusKey = card.getAttribute('data-key');
                                //         if (statusKey) {
                                //             let statusClass = `status-${statusKey.replace(/\s+/g, '-').toLowerCase()}`;
                                //             card.classList.add(statusClass);
                                //         }
                                //     });

                                self.selects.sales_status.forEach(status => {
                                    let className = `.status-${status.code.replace(/\s+/g, '-').toLowerCase()}`;

                                    let style = document.createElement('style');
                                    style.innerHTML = `
                                ${className} {
                                    border-left: 4px solid ${status.color || '#ccc'} !important;
                                }
                            `;
                                    document.head.appendChild(style);
                                });
                                // }

                                $('.kanbanCardUserImage').tooltip();
                                $('.projectCommentIcon').tooltip();

                                // document.querySelectorAll('div').forEach(div => {
                                //     // grab the full text inside the div, normalize whitespace & case
                                //     let txt = div.textContent.trim().toLowerCase();
                                //     if (txt.includes('license key is invalid')) {
                                //         div.remove();
                                //     }
                                // });

                                document.querySelectorAll('.e-header-title').forEach(item => {
                                    let columnCellName = item.querySelector('.e-header-text');
                                    let columnCellCount = item.querySelector('.e-item-count');
                                    let realColumnCardCount = self.dataKanban.filter(
                                        card => card.Status.trim() === columnCellName.innerHTML.trim() && !card.isDummy
                                    ).length;
                                    columnCellCount.textContent = realColumnCardCount+' Item';
                                });

                                document.querySelectorAll('.e-swimlane-row').forEach((row, idx) => {
                                    let swimlaneCells = row.querySelectorAll('td');
                                    // Debug: should be 1 cell per row
                                    console.log(swimlaneCells);

                                    // Find the item count span inside the first (and only) cell
                                    let countSpan = swimlaneCells[0]?.querySelector('.e-item-count');

                                    if (!countSpan) return;

                                    // Figure out the swimlane key for this row
                                    let swimlaneKey = safeHeaders[idx]?.key;

                                    // Count non-dummy cards for this swimlane
                                    let realCardCount = self.dataKanban.filter(
                                        card => card.swimlaneColumn === swimlaneKey && !card.isDummy
                                    ).length;

                                    // Set the correct count
                                    countSpan.textContent = realCardCount+' Item(s)';
                                });


                            }, 200);
                            return false;

                    });


                }
                this.kanban.refresh();
                this.filter.loadingData = false;

                setTimeout(() => {
                    $('.kanbanCardUserImage').tooltip();
                    $('.projectCommentIcon').tooltip();
                    document.querySelectorAll('.e-item-count').forEach(header => {
                        header.innerHTML = header.innerHTML.replace('-', '');
                    });
                    let safeHeaders = self.swimlaneRow.map(row => ({
                        key: row.key,
                        text: row.text
                    }));
                    let rowMap = {};
                    safeHeaders.forEach(r => {
                        rowMap[r.key] = r.text;
                    });

                    document.querySelectorAll('.e-swimlane-row td .e-swimlane-text').forEach(el => {
                        let original = el.textContent.trim();
                        let matched = Object.entries(rowMap).find(([key]) => original.includes(key));
                        if (matched) {
                            el.textContent = matched[1];
                        }
                    });

                    let dummyCards = [...document.querySelectorAll('.e-card[data-id*="__dummy__"]'), ...document.querySelectorAll('.e-card[data-id*="__DUMMY__"]'), ...document.querySelectorAll('.e-card[data-id*="undefined"]')];
                    dummyCards.forEach(card => {
                        let columnCell = card.closest('.e-content-cells');
                        card.remove(); // 👋 remove dummy card

                        // 🧠 Check if this column has no other real cards
                        let hasRealCards = columnCell.querySelectorAll('.e-card').length > 0;
                        let alreadyHasEmpty = columnCell.querySelector('.e-empty-card');

                        if (!hasRealCards && !alreadyHasEmpty) {
                            let emptyMessage = document.createElement('span');
                            emptyMessage.className = 'e-empty-card';
                            emptyMessage.setAttribute('role', 'option');
                            emptyMessage.setAttribute('aria-label', 'No cards to display');
                            emptyMessage.textContent = 'No cards to display';

                            columnCell.querySelector('.e-card-wrapper')?.appendChild(emptyMessage);
                        }
                    });

                    let contentRows = document.querySelectorAll('.e-kanban .e-content-row:not(.e-swimlane-row)');
                    contentRows.forEach((row, rowIndex) => {
                        let contentCells = row.querySelectorAll('.e-content-cells');

                        contentCells.forEach(cell => {
                            // Prevent duplicate buttons
                            if (cell.querySelector('.kanban-add-task-btn')) return;

                            // Extract the keyField from the column
                            let columnKey = cell.getAttribute('data-key');

                            // Fallback swimlane key logic from row index
                            let swimlaneKey = null;
                            if (this.swimlaneRow && this.swimlaneRow.length > rowIndex) {
                                swimlaneKey = this.swimlaneRow[rowIndex]?.key;
                            }

                            let addBtn = document.createElement('button');
                            addBtn.className = 'kanban-add-task-btn';
                            addBtn.textContent = '+ Add Project';
                            addBtn.onclick = () => {
                                let tempSelectList = [];
                                switch(self.selectedGroupBy.id){
                                    case 'sales_status_code':
                                        tempSelectList = self.selects.sales_status;
                                        break;
                                    default:
                                        tempSelectList = self.selects[self.selectedGroupBy.id];
                                        break;
                                }
                                let columnOBJ = tempSelectList.find(item => item.code === columnKey);

                                localStorage.setItem('kanban-group-by', (this.selectedGroupBy.id === 'sales_status_code')? 'sales_status_id': this.selectedGroupBy.id+'_id');
                                localStorage.setItem('kanban-sub-group-by', (this.selectedSubgroupBy)? JSON.stringify(this.selectedSubgroupBy):null);
                                localStorage.setItem('kanban-column', (columnOBJ)? columnOBJ.id:null);
                                localStorage.setItem('kanban-row', swimlaneKey);

                                window.location.href = '/project/create';
                                console.log('Add Task for:', {
                                    columnKey,
                                    swimlaneKey
                                });

                                // openTaskModal({ status: columnKey, swimlane: swimlaneKey });
                            };

                            let wrapper = document.createElement('div');
                            wrapper.className = 'kanban-add-wrapper';
                            wrapper.appendChild(addBtn);
                            cell.appendChild(wrapper);
                        });
                    });

                    let contentWrapper = document.querySelectorAll('.e-kanban .e-content-row:not(.e-swimlane-row) .e-card-wrapper');
                    document.querySelectorAll('.kanban-load-more-btn').forEach(loadMoreButton => {
                        loadMoreButton.remove();
                    });
                    contentWrapper.forEach((row, rowIndex) => {
                        let cards =row.querySelectorAll('.e-draggable');
                        let cardCount = cards.length;
                        let wrapper = document.createElement('div');
                        if (row.querySelector('.kanban-add-task-btn')) return;
                        let columnKey = row.getAttribute('aria-label');
                        let swimlaneKey = '';
                        if (this.swimlaneRow && this.swimlaneRow.length > rowIndex) {
                            swimlaneKey = this.swimlaneRow[rowIndex]?.key;
                        }
                        let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                        // if(self.selectedSubgroupBy){
                        //     let tempSubgroupBy = (self.selectedSubgroupBy)? self.selectedSubgroupBy:null;
                        //     if(swimlaneKey && tempSubgroupBy){
                        //         let tempSwimlaneKey = swimlaneKey.replace(/^\d+_/, '');
                        //         console.log('###########33', tempSwimlaneKey, tempSubgroupBy);
                        //         let filteredSwimlaneKey = null;
                        //         // if(tempSubgroupBy.property_name == 'account_manager_id' || tempSubgroupBy.property_name == 'estimator_id' || tempSubgroupBy.property_name == 'take_off_person_id'){
                        //         //     filteredSwimlaneKey = self.selects['users'].find(item => item.name === tempSwimlaneKey);
                        //         // }else{
                        //         //     filteredSwimlaneKey =  self.selects[tempSubgroupBy.property_name].find(item => item.code === tempSwimlaneKey);
                        //         // }
                        //         // if(filteredSwimlaneKey){
                        //         //     swimlaneKey = filteredSwimlaneKey.id;
                        //         // }
                        //     }
                        // }


                        let tempSelectList = [];
                        switch(self.selectedGroupBy.id){
                            case 'sales_status_code':
                                tempSelectList = self.selects.sales_status;
                                break;
                            default:
                                tempSelectList = self.selects[self.selectedGroupBy.id];
                                break;
                        }

                        let columnOBJ = tempSelectList.find(item => item.code === columnKey);
                        let columnId = (columnOBJ)? columnOBJ.id:null;


                        let loadMoreBtn = document.createElement('button');
                        loadMoreBtn.className = 'kanban-load-more-btn';
                        loadMoreBtn.textContent = 'Load more projects';
                        loadMoreBtn.onclick = () => {self.loadMoreProjects(columnId, cardCount, tempSwimlaneKey);};
                        wrapper.className = 'loadMoreButtonDiv';
                        wrapper.appendChild(loadMoreBtn);

                        row.appendChild(wrapper);
                    });

                    // if(self.selectedGroupBy && self.selectedGroupBy.id === 'sales_status_code'){
                    //     let cards = document.querySelectorAll('.e-kanban .e-card');
                    //         console.log(cards);
                    //     cards.forEach(card => {
                    //         let statusKey = card.getAttribute('data-key');
                    //         if (statusKey) {
                    //             let statusClass = `status-${statusKey.replace(/\s+/g, '-').toLowerCase()}`;
                    //             card.classList.add(statusClass);
                    //         }
                    //     });

                    self.selects.sales_status.forEach(status => {
                        let className = `.status-${status.code.replace(/\s+/g, '-').toLowerCase()}`;

                        let style = document.createElement('style');
                        style.innerHTML = `
                                ${className} {
                                    border-left: 4px solid ${status.color || '#ccc'} !important;
                                }
                            `;
                        document.head.appendChild(style);
                    });
                    // }

                    $('.kanbanCardUserImage').tooltip();
                    $('.projectCommentIcon').tooltip();

                    // document.querySelectorAll('div').forEach(div => {
                    //     // grab the full text inside the div, normalize whitespace & case
                    //     let txt = div.textContent.trim().toLowerCase();
                    //     if (txt.includes('license key is invalid')) {
                    //         div.remove();
                    //     }
                    // });

                }, 200);


            }, 700, this);


        },
        projectCommentModalOpen(){
            this.projectQuickViewData = null;
            $("#projectCommentSectionModal").modal("show");
            this.getPanelProjectData();
        },
        closeProjectCommentSectionModal() {
            this.projectCommentForm.reset();
            $("#projectCommentSectionModal").modal("hide");
        },
        projectSortingDirection(direction){
            this.layoutSetting.sortDirection = direction;
        },
        projectSortingColumn(column){
            this.layoutSetting.sortColumn = column;
        },
        getSalesStatusColumnsFormated(){
            let tempSalesStatusColumn = [];
            this.selects.sales_status.forEach(column => {
                column.checked = 'true';
                column.key = this.strRandom();
                tempSalesStatusColumn.push(column);
            });
            return tempSalesStatusColumn;
        },
        strRandom(length = 8) {
            let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        },
        takeToProjectListPage(){
            axios.post(route('project.user-update-project-listing'), {'page': 'list'}).then(response => {
                window.location.href = "/project";
            });
        },
        loadMoreProjects(column, cardCount, swimlaneKey) {

            if(this.searchText){
                this.applyKanbanSearch();
                return false;
            }

            console.log(column, cardCount, swimlaneKey);
            let el = document.getElementById('kanban-container');
            this.showKanbanLoader = true;
            el.style.opacity = '0.3';
            el.style.filter = 'blur(2px)';
            el.style.transition = 'opacity 0.5s ease-out';
            this.columnToFetchDataFor = column;
            this.projectToFetch = this.projectToFetch + 100;
            this.projectToSkip = this.projectToFetch - 100;
            console.log(this.projectToFetch);
            this.getProjectsKanban('loadMore');
        },
        showCustomizePanel(){
            this.previousLayoutSetting = JSON.parse(JSON.stringify(this.layoutSetting));
            this.isCustomizePanel = true;
        },
        hideCustomizePanel(){
            this.layoutSetting = JSON.parse(JSON.stringify(this.previousLayoutSetting));
            this.cardSize(this.layoutSetting.cardSize);
            this.isCustomizePanel = false;
        },
    }
};
</script>

<style>
#kanban-container,
.e-kanban-content,
.e-kanban-table {
    max-width: 100%;
    overflow-x: auto;
}

/*
.e-header-cells,
.e-content-cells {
    width: 220px !important;
    min-width: 220px !important;
}
*/

.e-kanban .e-kanban-table {
    table-layout: auto !important;
}

.e-collapsed {
    width: 100% !important;
    max-width: 85px !important;
    min-width: 85px !important;
}


.e-collapse-header-text {
    font-size: 14px !important;
    font-weight: bold !important;
    font-family: 'Roboto' !important;
    padding: 8px 0 !important;
    margin: 20px auto !important;
}

.kanban-grouping-filter .multiselect__placeholder {
    padding: 7px;
}

.kanban-grouping-filter .multiselect__tags {
    width: 222px;
}

/*
.e-card[data-id*="__dummy__"] {
    display: none !important;
}
*/

.e-card-wrapper {
    max-height: 500px !important;
    overflow-y: auto;
}

.kanban-add-wrapper {
    padding: 8px;
    text-align: center;
    background-color: #f9f6fb;
}

.kanban-add-task-btn {
    background: none;
    border: none;
    color: #6b7280;
    font-size: 14px;
    cursor: pointer;
    transition: color 0.3s;
}

.kanban-add-task-btn:hover {
    color: #8b5cf6;
}

.kanban-add-task-btn {
    color: black !important;
    background: #00000005;
    width: 100%;
    padding: 10px;
    border-radius: 5px;
}

.e-card-wrapper {
    overflow: auto; /* or scroll */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
}

.e-card-wrapper::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
}

.custom-kanban-card .card-header,
.custom-kanban-card .card-body {
    padding: 0;
}
.e-kanban-table .e-selection,
.e-kanban-table .e-selection:hover,
.e-kanban-table .e-selection:focus
{
    background: #fff !important;
    padding: 0 !important;
}

.kanban-side-panel {
    position: absolute;
    top: 74px;
    right: 0;
    width: 450px;
    height: fit-content;
    min-height: 890px;
    background: white;
    box-shadow: -2px 0 10px rgba(0, 0, 0, .1);
    padding: 20px;
    z-index: 999;
    overflow-y: scroll;
    transition: transform 0.3s ease-in-out;
    overflow-x: hidden;
}
.kanban-side-panel .side-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    transform: translateX(0%);
}

.kanban-side-panel .side-panel-footer {
    text-align: right;
    margin-top: 2rem;
}

.kanban-field-check .custom-checkbox{
    padding: 0 !important;
    margin-top: 0 !important;
    width: 100%;
    max-width: 80%;
}

.kanban-field-check:hover{
    background-color: #4dc0b5 !important;
}

.e-card {
    padding-left: 0;
}

.side-panel-content .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #01b1af !important;
    background-color: #01b1af !important;
}

.kanbanCardFieldName {
    font-size: 12px;
    font-weight: bolder;
    color: #898989;
}

.kanbanCardFieldDiv {
    margin-bottom: 10px;
    word-wrap: break-word;
}

.kanbanCardUserImage {
    width: 45px;
    height: 45px;
    background-size: cover !important;
    border-radius: 50%;
    border: 2px solid white;
    box-shadow: 0 0 2px 0 #38b2b0;
}

.kanbanCardFieldDivImage {
    float: left;
    margin-right: -10px;
    margin-bottom: 5px;
}

.e-collapsed .kanban-add-task-btn{
    display: none;
}

.kanbanCardCommentFieldDiv {
    display: block;
    width: 100%;
    overflow: hidden;
    text-align: right;
    font-size: 0;
    margin-bottom: 7px;
    color: #38b2b0;
}

.projectKanbanCommentDiv{
    height: 40vh;
    overflow-y: scroll;
}

.kanban-toggle-custom .custom-switch{
    margin-top: 2px !important;
}
.kanban-loader-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    font-size: 18px;
    color: #333;
}

.kanban-loader-content {
    text-align: center;
}
.kanban-loader-content i {
    font-size: 24px;
    margin-bottom: 10px;
    display: block;
}

button.kanban-load-more-btn {
    text-align: center;
    width: 100%;
    padding: 13px 0;
    background: #ffffffcc;
    border-radius: 3px;
    font-size: 15px;
}
</style>
